<form [formGroup]="form" (click)="$event.stopPropagation()" [intercomTarget]="'form-operation-input'">
  <div class="filter-display-box" *ngIf="visibilityConfig.fieldName">
    <div class="filter-header aligner-start">
      <y42-column-type-icon [type]="column.data_type!"></y42-column-type-icon>
      <span class="ml-1">{{ column.description ? column.description : column.field_name || '' }}</span>
    </div>
  </div>
  <div class="filter-dialog-content">
    <div class="operation-wrapper">
      <y42-operation-input-boolean *ngIf="state.showOperationInputBoolean"> </y42-operation-input-boolean>

      <y42-operation-input-text
        *ngIf="state.showOperationInputText && !showSelect"
        [columnType]="column.data_type"
        [predefinedValues]="predefinedValues"
        [enableMoreConditions]="enableMoreConditions"
        [operatorOptions]="operatorOptions"
        (loadAutoProposal)="loadAutoProposal.emit()"
      >
      </y42-operation-input-text>
      <y42-operation-input-select
        *ngIf="state.showOperationInputText && showSelect"
        [columnType]="column.data_type"
        [predefinedValues]="predefinedValues"
        [operatorOptions]="operatorOptions"
        (loadAutoProposal)="loadAutoProposal.emit()"
      >
      </y42-operation-input-select>
      <y42-operation-input-number
        *ngIf="state.showOperationInputNumber"
        [columnType]="column.data_type"
        [enableMoreConditions]="enableMoreConditions"
        [operatorOptions]="operatorOptions"
      >
      </y42-operation-input-number>
      <y42-operation-input-date-time
        *ngIf="state.showOperationInputDate"
        [columnType]="column.data_type"
        [showRelativeDates]="showRelativeDates"
        [absoluteRangePresets]="absoluteDateRangePresets"
        [relativeRangePresets]="relativeDateRangePresets"
        [enableMoreConditions]="enableMoreConditions"
        [operatorOptions]="operatorOptions"
        [minDate]="minDate"
        [maxDate]="maxDate"
      >
      </y42-operation-input-date-time>
    </div>
  </div>
  <div class="filter-actions" *ngIf="visibilityConfig.applyButton || visibilityConfig.resetButton">
    <button
      *ngIf="visibilityConfig.applyButton"
      mat-raised-button
      class="filter-action-button apply-btn"
      color="primary"
      aria-label="Apply"
      type="button"
      [disabled]="!state.isFormValid"
      [intercomTarget]="'button-operation-input-apply'"
      data-test="button-operation-input-submit"
      (click)="apply()"
    >
      Apply
    </button>

    <button
      *ngIf="visibilityConfig.resetButton"
      mat-button
      type="button"
      class="filter-action-button reset-btn"
      aria-label="Reset"
      color="primary"
      [intercomTarget]="'button-operation-input-reset'"
      data-test="button-operation-input-reset"
      (click)="reset()"
    >
      Reset
    </button>
  </div>
</form>
